import React from 'react';
import autoBind from 'react-autobind';
import { PageHeader, message, Layout, Row, Col, Table, Button, Tooltip, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
//
import CommonLoadingView from '../../commonComponents/CommonLoadingView';
import CustomComponent from '../../../components/CustomComponent';
//
import Globals from '../../../config/Globals';
import config from '../../../config/config';
import Utils from '../../../components/Utils';
//
export default class AdminTemplatesView extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      templates: [],
      sortedInfo: { columnKey: 'internalName', order: 'ascend' },
    };
  }

  async componentDidMount() {
    super.componentDidMount();
    this.fetchData();
  }

  async fetchData() {
    this.startLoading();
    const resp = await this._loadAll();
    if (resp) this.setState({ ...resp, isLoading: false });
    else this.stopLoading();
  }

  //Actions
  //Table
  handleFilterChange(pagination, filters, sorter) {
    this.setState({ sortedInfo: sorter });
  }
  //Table row actions
  handleEditTemplate(templateID) {
    this.props.app.urlManager.pushPage(config.ApplicationRoutes.template, null, templateID);
  }
  handleAddTemplate() {
    this.props.app.urlManager.pushPage(config.ApplicationRoutes.template, null, Globals.URL_NewIndentifier);
  }
  async handleDeleteTemplate(templateID) {
    //Only sysadmins
    if (!this.props.app.isSysAdmin()) {
      this.props.alertController.showErrorAlert(
        'Ops..',
        'You are not allowed to delete session templates. If you really need to delete a template, please, contact the system administrator.'
      );
      return;
    }
    //
    this.startLoading();
    const resp = await this._deleteTemplate(templateID);
    if (resp) await this.fetchData();
    this.stopLoading();
  }
  //UI
  render() {
    return (
      <Layout.Content className="pageContent">
        <CommonLoadingView isLoading={this.state.isLoading} isFixed />
        <PageHeader className="pageHeader" title="Templates" onBack={() => this.props.app.urlManager.pushBack()} />
        <Layout.Content>
          <Row type="flex" justify="end">
            <Col>
              {' '}
              <Button style={{ marginBottom: 20 }} type="primary" onClick={this.handleAddTemplate}>
                {' '}
                Add Template{' '}
              </Button>{' '}
            </Col>
          </Row>
          {this._renderTemplatesTable()}
        </Layout.Content>
      </Layout.Content>
    );
  }

  /* private UI */
  _renderTemplatesTable() {
    const courses = this.props.app.sharedCache().getAllUniqueCourses();
    let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};
    const columns = [
      {
        title: 'Internal Name',
        key: 'internalName',
        dataIndex: 'internalName',
        sorter: (a, b) => a.internalName.localeCompare(b.internalName),
        sortOrder: sortedInfo.columnKey === 'internalName' && sortedInfo.order,
      },
      {
        title: 'Name',
        key: 'name',
        dataIndex: 'name',
        sorter: (a, b) => a.name.localeCompare(b.name),
        sortOrder: sortedInfo.columnKey === 'name' && sortedInfo.order,
      },
      {
        title: 'Course',
        key: 'courseID',
        sorter: (a, b) =>
          (courses.find((c) => c.id == a.courseID)?.description || '').localeCompare(
            courses.find((c) => c.id == b.courseID)?.description || ''
          ),
        sortOrder: sortedInfo.columnKey === 'courseID' && sortedInfo.order,
        render: (props) => courses.find((c) => c.id == props.courseID)?.description || '',
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        sorter: (a, b) => a.type.localeCompare(b.type),
        sortOrder: sortedInfo.columnKey === 'type' && sortedInfo.order,
        render: (props) => Globals.getTemplateTypeIcon(props, true),
      },
      {
        title: 'Capacity',
        dataIndex: 'capacity',
        key: 'capacity',
        sorter: (a, b) => (a.capacity || 0) - (b.capacity || 0),
        sortOrder: sortedInfo.columnKey === 'capacity' && sortedInfo.order,
        render: (props) => (props < 0 ? 'Unlimited' : props),
      },
      {
        title: 'Added On',
        key: 'createdOn',
        width: '15%',
        render: (props) => (props.createdOn ? Utils.getDateOnUIFormatByTimestamp(props.createdOn) : 'N/A'),
        sorter: (a, b) => a.createdOn - b.createdOn,
        sortOrder: sortedInfo.columnKey === 'createdOn' && sortedInfo.order,
      },
      {
        title: 'Actions',
        width: 'auto',
        key: 'Actions',
        width: '15%',
        render: (props) => {
          return (
            <span className="tableButtonContainer">
              <Tooltip placement="bottomLeft" title="Edit">
                <Button
                  style={{ marginLeft: 5 }}
                  variant="none"
                  icon={<EditOutlined />}
                  shape="circle"
                  onClick={this.handleEditTemplate.bind(this, props.id)}
                />
              </Tooltip>
              <Tooltip placement="bottomLeft" title="Delete">
                <Popconfirm
                  placement="top"
                  title={`Are you sure that you want to delete the template '${props.internalName}'?`}
                  onConfirm={this.handleDeleteTemplate.bind(this, props.id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button style={{ marginLeft: 5 }} variant="none" icon={<DeleteOutlined />} shape="circle" />
                </Popconfirm>
              </Tooltip>
            </span>
          );
        },
      },
    ];
    const props = {
      rowKey: 'id',
      loading: this.state.isLoading,
      onChange: this.handleFilterChange,
      locale: { emptyText: 'No templates found!' },
      pagination: {
        pageSize: Globals.Table_PagingItemsPerPage,
        hideOnSinglePage: true,
        showSizeChanger: false,
        position: ['bottomCenter'],
      },
    };
    return (
      <Layout.Content>
        <Table className="adminTemplatesTable" columns={columns} dataSource={this.state.templates} {...props} />
      </Layout.Content>
    );
  }

  /* private API */
  async _loadAll() {
    const resp = await Promise.all([this.props.app.classroom.template.getTemplates()]);
    if (!(resp[0].statusCode == 200 && resp[0].body && resp[0].body.templates)) {
      this.props.app.alertController.showAPIErrorAlert(null, resp[0]);
      return false;
    }
    return { templates: resp[0].body.templates };
  }
  async _deleteTemplate(templateID) {
    const resp = await this.props.app.classroom.template.deleteTemplate(templateID);
    if (resp.statusCode == 200) {
      message.success('Template deleted with success!');
      return true;
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, resp);
      return false;
    }
  }
}
